// 日期格式转换方法
export default {
	install(Vue, options) {

		Vue.prototype.timeToDate = function(timestamp, i) {
			var format = 'yyyy-MM-dd hh:mm:ss';
			var i = i || 1000;
			var date = new Date(parseInt(timestamp * i, 10)),
				o = {
					"M+": date.getMonth() + 1,
					"d+": date.getDate(),
					"h+": date.getHours(),
					"m+": date.getMinutes(),
					"s+": date.getSeconds(),
					"q+": Math.floor((date.getMonth() + 3) / 3),
					"S": date.getMilliseconds()
				};

			if(/(y+)/.test(format)) {
				format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
			}

			for(var k in o) {
				if(new RegExp("(" + k + ")").test(format)) {
					format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}
			}
			return format;
		};
		// 无时、分、秒
		Vue.prototype.timeToDay = function(timestamp, i) {
			var format = 'yyyy-MM-dd';
			var i = i || 1000;
			var date = new Date(parseInt(timestamp * i, 10)),
				o = {
					"M+": date.getMonth() + 1,
					"d+": date.getDate(),
					"h+": date.getHours(),
					"m+": date.getMinutes(),
					"s+": date.getSeconds(),
					"q+": Math.floor((date.getMonth() + 3) / 3),
					"S": date.getMilliseconds()
				};

			if(/(y+)/.test(format)) {
				format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
			}

			for(var k in o) {
				if(new RegExp("(" + k + ")").test(format)) {
					format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}
			}
			return format;
		};
		
	  
	}
}


// WEBPACK FOOTER //
// ./src/api/Date.js